// src/pages/ManageAccounts.jsx
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import '../styles/ManageAccounts.css'; // Buat file CSS ini
import { FaEdit, FaKey, FaUserEdit } from 'react-icons/fa'; // Import ikon

const ManageAccounts = () => {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const [editingAccountId, setEditingAccountId] = useState(null); // ID akun yang sedang diedit
    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState(''); // Konfirmasi password

    const token = localStorage.getItem('token');

    const fetchAccounts = useCallback(async () => {
        setLoading(true);
        setError('');
        setMessage('');
        try {
            // Menggunakan endpoint accounts yang sudah ada dari superAdminTablesRoutes.js
            const response = await axios.get('https://depotaircerdas.com/api/superadmin/tables/accounts?_limit=1000', { // Ambil semua atau sesuaikan limit
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (Array.isArray(response.data)) {
                setAccounts(response.data);
            } else {
                setError("Format data akun tidak sesuai.");
                setAccounts([]);
            }
        } catch (err) {
            console.error('Error fetching accounts:', err);
            setError('Gagal mengambil daftar akun. ' + (err.response?.data?.message || err.message));
            setAccounts([]);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            fetchAccounts();
        }
    }, [token, fetchAccounts]);

    const handleEditClick = (account) => {
        setEditingAccountId(account.id);
        setNewUsername(account.username); // Isi dengan username saat ini
        setNewPassword(''); // Kosongkan password
        setPasswordConfirmation('');
        setMessage('');
        setError('');
    };

    const handleCancelEdit = () => {
        setEditingAccountId(null);
        setNewUsername('');
        setNewPassword('');
        setPasswordConfirmation('');
    };

    const handleChangeUsername = async (accountId) => {
        if (!newUsername || newUsername.trim() === '') {
            setError("Username baru tidak boleh kosong.");
            return;
        }
        if (newUsername === accounts.find(acc => acc.id === accountId)?.username) {
            setMessage("Username tidak berubah.");
            setEditingAccountId(null);
            return;
        }

        setLoading(true);
        setError('');
        setMessage('');
        try {
            const response = await axios.put(`https://depotaircerdas.com/api/superadmin/tables/accounts/change-username/${accountId}`, { newUsername }, {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
            });
            setMessage(response.data.message);
            handleCancelEdit();
            fetchAccounts(); // Refresh daftar akun
        } catch (err) {
            console.error('Error changing username:', err);
            setError(err.response?.data?.message || "Gagal mengubah username.");
        } finally {
            setLoading(false);
        }
    };

    const handleChangePassword = async (accountId) => {
        if (!newPassword || newPassword.length < 6) {
            setError("Password baru tidak valid. Minimal 6 karakter.");
            return;
        }
        if (newPassword !== passwordConfirmation) {
            setError("Konfirmasi password tidak cocok.");
            return;
        }

        setLoading(true);
        setError('');
        setMessage('');
        try {
            const response = await axios.put(`https://depotaircerdas.com/api/superadmin/tables/accounts/change-password/${accountId}`, { newPassword }, {
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
            });
            setMessage(response.data.message);
            handleCancelEdit();
            fetchAccounts(); // Refresh daftar akun
        } catch (err) {
            console.error('Error changing password:', err);
            setError(err.response?.data?.message || "Gagal mengubah password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="manage-accounts-container">
            <h2>Manajemen Akun Pengguna</h2>
            <button onClick={fetchAccounts} disabled={loading} className="btn-refresh">
                {loading ? 'Memuat...' : 'Refresh Daftar Akun'}
            </button>
            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}

            {loading && <p>Memuat akun...</p>}
            {!loading && accounts.length === 0 ? (
                <p>Tidak ada akun terdaftar.</p>
            ) : (
                <div className="accounts-list">
                    {accounts.map(account => (
                        <div key={account.id} className="account-card">
                            <div className="account-info">
                                <b>Username:</b> {account.username}<br />
                                <b>Nama Depot:</b> {account.depot_name}<br />
                                <b>Alamat:</b> {account.address}<br />
                                <b>Super Admin:</b> {account.is_super_admin === 1 ? 'Ya' : 'Tidak'}
                            </div>

                            {editingAccountId === account.id ? (
                                <div className="edit-form">
                                    <h4>Edit Akun {account.username}</h4>
                                    <label>Username Baru:</label>
                                    <input
                                        type="text"
                                        value={newUsername}
                                        onChange={(e) => setNewUsername(e.target.value)}
                                        placeholder="Username baru"
                                    />
                                    <button className="btn-action" onClick={() => handleChangeUsername(account.id)} disabled={loading}><FaUserEdit /> Ganti Username</button>

                                    <label>Password Baru:</label>
                                    <input
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="Password baru"
                                    />
                                    <label>Konfirmasi Password:</label>
                                    <input
                                        type="password"
                                        value={passwordConfirmation}
                                        onChange={(e) => setPasswordConfirmation(e.target.value)}
                                        placeholder="Konfirmasi password baru"
                                    />
                                    <button className="btn-action" onClick={() => handleChangePassword(account.id)} disabled={loading}><FaKey /> Ganti Password</button>

                                    <button className="btn-cancel" onClick={handleCancelEdit} disabled={loading}>Batal</button>
                                </div>
                            ) : (
                                <button className="btn-edit" onClick={() => handleEditClick(account)}>
                                    <FaEdit /> Edit Akun
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ManageAccounts;